import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_ufksvfnt9a: FaireCollectionEntity = {
  token: "pbc_ufksvfnt9a",
  type: "collection",
  name: "Milan Pastel Classic Sweater Knits Baby Collection (Organic)",
  heroImageUrl:
    "https://cdn.faire.com/fastly/766ae6177948e4bfa3b2733163c339b99f9684f6c895971270c9c42d8e225042.jpeg",
  itemCount: 45,
  description:
    "Classic & elegant designs made with 100% organic cotton. \nUltra Soft, lightweight, all-season, cozy and comfy.\nChemical free & non-toxic formulation, eco-friendly. \nEthically produced in India, supporting better livelihoods for small grower farmers.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:18.292Z",
    importedBy: "entity-db-import-collections",
  },
};
